module.exports = __webpack_public_path__ + "img/etnet-20210817.73709dd3.jpg";